<template>
  <div>
    <q-table
      class="q-my-sm"
      :columns="columns"
      :rows="rows"
      row-key="unitName"
      v-model:pagination="pagination"
      grid
      hide-header
      hide-bottom
    >
      <template v-slot:item="props">
        <div class="q-pa-xs grid-style-transition">
          <q-card
            align="left"
            style="min-width: 180px"
          >
            <q-card-section>
              <div>
                <span class="text-weight-bold">{{ props.row.unitName }}</span>
                <q-icon
                  name="pets"
                  color="negative"
                  size="sm"
                  class="q-ml-sm"
                  :style="{
                    visibility: hasEsaConflict(props.row.placementModels)
                      ? 'visible' : 'hidden'
                  }"
                >
                  <q-tooltip v-if="hasEsaConflict(props.row.placementModels)">
                    ESA Conflict - This unit has mixed ESA status
                  </q-tooltip>
                </q-icon>
                <q-icon
                  v-if="hasGenderConflict(props.row.placementModels)"
                  name="people"
                  color="negative"
                  size="sm"
                  class="q-ml-sm"
                >
                  <q-tooltip>
                    Gender Preference Conflict - Student gender not in roommate preferences
                  </q-tooltip>
                </q-icon>
                <q-btn
                  class="float-right"
                  size="xs"
                  color="white"
                  text-color="primary"
                  round
                  flat
                  icon="edit"
                  @click="isSubmitModalActive = true, updateCurrentUiRow(props.row)"
                >
                </q-btn>
              </div>
            </q-card-section>
            <q-separator />
            <q-list
              separator
              dense
            >
              <q-item
                v-for="row in props.row.placementModels"
                :key="row.placementId"
                @click="updateCurrentUiPlacement(row)"
                :style="{ 'background-color' :
                  row?.username === props.row?.ra?.username ? '#FFAB57' :
                  row?.trait === 'Dss' ? 'grey' :
                  row?.trait === 'EmergencyUse' ? 'pink' :
                  row?.trait === 'FacilitiesIssue' ? 'pink' :
                  row?.trait === 'Sponsorship' ? 'pink' :
                  row?.trait === 'RA' ? 'pink' :
                  row?.trait === 'PendingOnboardingOffboarding' ? 'pink' :
                  row?.trait === 'Buyout' ? '#b9cfe4' :
                  row?.placementStatus === 'Unassigned' ? '#ffef9e' :
                  row?.placementStatus === 'Placed' ? '#ffffff' :
                  row?.placementStatus === 'Tentative' ? '#b5d694' :
                  row?.placementStatus === 'Blocked' ? '#A1856A' : 'red',
                  'opacity' : row.isLocked ? '0.7' : '1' }"
              >
                <!-- <q-popup-edit
                  v-model="popupEdit"
                  anchor="top left"
                  class="q-gutter-sm bg-blue-grey-1"
                  persistent
                >
                  <q-select
                    :modelValue="row.fullName"
                    use-input
                    hide-selected
                    fill-input
                    input-debounce="0"
                    :disable="row.placementStatus === 'Blocked'"
                    :readonly="row.placementStatus === 'Placed'"
                    :borderless="row.placementStatus === 'Placed'
                      || row.placementStatus === 'Blocked'"
                    :hide-dropdown-icon="row.placementStatus === 'Placed'
                      || row.placementStatus === 'Blocked'"
                    :options="studentNameOptions"
                    @filter="studentNameFilter"
                    @update:model-value="setUserIdGivenName(row, $event)"
                    label="Student Name"
                    clearable
                  >
                    <template v-slot:no-option>
                      <q-item>
                        <q-item-section class="text-grey">
                          No results
                        </q-item-section>
                      </q-item>
                    </template>
                  </q-select>
                  <q-checkbox
                    v-model="row.isLocked"
                    label="Locked"
                    autofocus
                  />
                  <div class="row">
                    <q-btn
                      class="col-4 q-ma-md"
                      @click="resetCurrentPlacement(); updateStudentNamelist(sessionId)"
                      color="grey"
                      label="Cancel"
                      size="md"
                      v-close-popup
                    />
                    <q-btn
                      class="col-4 q-ma-md"
                      color="primary"
                      label="Save"
                      @click="updateSinglePlacement(row); updateStudentNamelist(sessionId)"
                      size="md"
                      v-close-popup
                    />
                  </div>
                </q-popup-edit> -->
                <q-item-section>
                  <q-item-label caption>
                    <span class="text-weight-bold">
                      {{ row.fullName ? row.fullName
                                      : (row.placementStatus === 'Blocked'
                                        ? 'Blocked' : 'Unassigned') }}
                    </span>
                    <q-badge
                      v-if="row.isUnder18 && row.fullName"
                      color="deep-orange"
                      class="q-ml-xs"
                      rounded
                    >
                      Under 18
                      <q-tooltip class="text-body2">
                        Under 18 as of move-in parental sign-off required
                        on housing agreements and contracts.
                      </q-tooltip>
                    </q-badge>
                    <q-badge
                      v-if="row.is25OrOlder && row.fullName"
                      color="indigo"
                      class="q-ml-xs"
                      rounded
                    >
                      25+
                      <q-tooltip class="text-body2">
                        Student is 25 or older as of move-in.
                      </q-tooltip>
                    </q-badge>
                    <span v-if="isShowingUsername && row.username">
                      | {{ row.username }}@digipen.edu
                    </span>
                    <span v-if="isShowingColleagueId && row.colleagueId">
                      | {{ row.colleagueId }}
                    </span>
                    | {{ row.roomModel?.roomType }}
                  </q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-card>
        </div>
      </template>
    </q-table>
    <q-dialog
      ref="submitModal"
      v-model="isSubmitModalActive"
      persistent
    >
      <q-card style="width: 1180px; max-width: 90vw;">
        <q-card-section>
          <q-tabs
            v-model="editPlacementTab"
            no-caps
          >
            <q-tab
              name="editPlacement"
              label="Edit Placements"
              @click="onEditPlacementTabClick"
            />
            <q-tab
              name="unitAudit"
              label="Unit Audit"
              @click="checkUnsavedChangesBeforeTabChange"
            />
          </q-tabs>
          <q-separator />
          <q-tab-panels
            ref="tabs"
            v-model="editPlacementTab"
            animated
            keep-alive
          >
            <q-tab-panel name="editPlacement">
              <SubmitPlacement
                ref="placementForm"
                :sessionId="sessionId"
              />
            </q-tab-panel>
            <q-tab-panel name="unitAudit">
              <PlacementAudit :sessionId="sessionId" />
            </q-tab-panel>
          </q-tab-panels>
        </q-card-section>
        <q-card-actions
          align="center"
          class="bg-white text-teal"
        >
          <q-btn
            flat
            label="Cancel"
            color="primary"
            @click="checkUnsavedChangesBeforeClose"
          />
          <q-btn
            flat
            label="Save"
            @click="submitPlacementForm()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog v-model="showUnsavedChangesDialog" persistent>
      <q-card>
        <q-card-section class="row items-center">
          <q-avatar icon="warning" color="warning" text-color="white" />
          <span class="q-ml-sm">You have unsaved changes. Discard them?</span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Cancel" color="primary" v-close-popup />
          <q-btn flat label="Discard Changes" color="negative"
          @click="confirmDiscardChanges" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useQuasar } from 'quasar';
import usePlacement from '@/hooks/placement';
import useUser from '@/hooks/user';
import SubmitPlacement from './SubmitPlacement.vue';
import PlacementAudit from './PlacementAudit.vue';

const columns = [
  {
    name: 'Complex Name',
    label: 'Unit',
    align: 'left',
    field: 'complexName',
    format: (val) => `${val}`,
    sortable: true,
  },
  {
    name: 'RA Name', align: 'center', label: 'RA Name', field: 'raName',
  },
];

export default {
  props: {
    complexId: Number,
    raId: Number,
    sessionId: Number,
    searchFilter: String,
  },
  async setup(props) {
    const $q = useQuasar();
    $q.loading.show();
    const {
      currentUnitPlacement,
      fetchPlacementsByComplexAndRa,
      isShowingUsername,
      isShowingColleagueId,
      studentNameList,
      updatePlacement,
      updateStudentNamelist,
    } = usePlacement();
    const { getUserNameIds } = useUser();

    const rows = ref([]);
    const isSubmitModalActive = ref(false);
    const submitModal = ref(null);
    const placementForm = ref(null);
    const applicantList = ref([]);
    const prevUnitPlacement = ref(null);
    const prevPlacement = ref(null);
    const editPlacementTab = ref('editPlacement');
    const showUnsavedChangesDialog = ref(false);
    const pendingAction = ref(null);

    const pagination = ref({
      rowsPerPage: 0, // displays all
      rowsNumber: -1,
      page: 1,
      sortBy: '',
      descending: false,
    });

    if (props.complexId) {
      const response = await fetchPlacementsByComplexAndRa(
        props.complexId, props.raId, props.sessionId, props.searchFilter,
      );
      rows.value = response.data.data;
    }

    const submitPlacementForm = async () => {
      const response = await placementForm.value.onSubmit();
      if (response.status === 200 || response.status === 201) {
        if (submitModal.value) {
          submitModal.value.hide();
        }
      }
    };

    applicantList.value = await getUserNameIds(props.sessionId);

    await updateStudentNamelist(props.sessionId);

    const studentNameOptions = ref(studentNameList.value);

    const setUserIdGivenName = (row, newFullName) => {
      row.userId = newFullName?.value; // eslint-disable-line no-param-reassign
      row.fullName = newFullName?.label; // eslint-disable-line no-param-reassign
    };

    const updateSinglePlacement = async (placement) => {
      $q.loading.show();
      const response = await updatePlacement(placement);
      if (response.status === 200 || response.status === 201) {
        // selectedFullName.value = null;
      }
      $q.loading.hide();
    };

    const updateCurrentUiRow = (row) => {
      prevUnitPlacement.value = JSON.parse(JSON.stringify(row));
      currentUnitPlacement.value = row;
      editPlacementTab.value = 'editPlacement';
    };

    const addCurrentToUnPlacedList = (row) => {
      if (row.fullName && !studentNameList.value.includes({
        value: row.userId,
        label: row.fullName,
      })) {
        studentNameList.value.push({ value: row.userId, label: row.fullName });
      }
    };

    const updateCurrentUiPlacement = async (row) => {
      prevPlacement.value = JSON.parse(JSON.stringify(row));
      await updateStudentNamelist(props.sessionId);
      addCurrentToUnPlacedList(row);
    };

    const resetCurrentPlacement = () => {
      if (prevPlacement.value.fullName !== null) {
        const indexToRemove = studentNameList.value.indexOf(
          {
            value: prevPlacement.value.userId,
            label: prevPlacement.value.fullName,
          },
        );
        if (indexToRemove > -1) {
          studentNameList.value.splice(indexToRemove, 1);
        }
      }
      for (let i = 0; i < rows.value.length; i += 1) {
        if (rows.value[i].unitPlacementsId === prevPlacement.value.unitPlacementsId) {
          for (let j = 0; j < rows.value[i].placementModels.length; j += 1) {
            if (rows.value[i].placementModels[j].placementId === prevPlacement.value.placementId) {
              rows.value[i].placementModels[j] = prevPlacement.value;
              break;
            }
          }
        }
      }
    };

    const resetCurrentRow = () => {
      for (let i = 0; i < rows.value.length; i += 1) {
        if (rows.value[i].unitPlacementsId === prevUnitPlacement.value.unitPlacementsId) {
          rows.value[i] = prevUnitPlacement.value;
        }
      }
    };

    const hasUnsavedChanges = () => {
      if (!placementForm.value || !prevUnitPlacement.value) return false;

      const hasNewPlacements = placementForm.value.checkForNewPlacement();

      const hasDataChanges = placementForm.value.placementDetails
      && JSON.stringify(placementForm.value.placementDetails)
      !== JSON.stringify(prevUnitPlacement.value);

      return hasNewPlacements || hasDataChanges;
    };

    const checkUnsavedChangesBeforeTabChange = (event) => {
      if (editPlacementTab.value === 'editPlacement' && hasUnsavedChanges()) {
        event.preventDefault();
        pendingAction.value = 'changeTab';
        showUnsavedChangesDialog.value = true;
      }
    };

    const checkUnsavedChangesBeforeClose = () => {
      if (editPlacementTab.value === 'editPlacement' && hasUnsavedChanges()) {
        pendingAction.value = 'close';
        showUnsavedChangesDialog.value = true;
      } else {
        resetCurrentRow();
        isSubmitModalActive.value = false;
      }
    };

    const confirmDiscardChanges = () => {
      const actions = {
        changeTab: () => {
          if (placementForm.value?.resetToOriginalState) {
            placementForm.value.resetToOriginalState();
          }
          editPlacementTab.value = 'unitAudit';
        },
        close: () => {
          resetCurrentRow();
          isSubmitModalActive.value = false;
        },
      };

      const action = actions[pendingAction.value];
      if (action) {
        action();
      }

      pendingAction.value = null;
    };

    const onEditPlacementTabClick = () => {
      if (placementForm.value && placementForm.value.resetToOriginalState) {
        placementForm.value.resetToOriginalState();
      }
    };

    $q.loading.hide();
    return {
      columns,
      currentUnitPlacement,
      isShowingUsername,
      isShowingColleagueId,
      isSubmitModalActive,
      pagination,
      placementForm,
      popupEdit: ref(''),
      prevUnitPlacement,
      rows,
      resetCurrentRow,
      resetCurrentPlacement,
      setUserIdGivenName,
      studentNameOptions,
      submitModal,
      submitPlacementForm,
      updateCurrentUiRow,
      updateCurrentUiPlacement,
      updateSinglePlacement,
      updateStudentNamelist,
      editPlacementTab,
      showUnsavedChangesDialog,
      checkUnsavedChangesBeforeTabChange,
      checkUnsavedChangesBeforeClose,
      confirmDiscardChanges,
      onEditPlacementTabClick,

      studentNameFilter(val, update) {
        update(() => {
          const needle = val.toLowerCase();
          studentNameOptions.value = studentNameList.value.filter(
            (v) => v.label.toLowerCase().indexOf(needle) > -1,
          );
        });
      },

      hasEsaConflict(placementModels) {
        if (!placementModels || placementModels.length < 2) return false;

        const occupiedPlacements = placementModels.filter((p) => p.fullName);
        if (occupiedPlacements.length < 2) return false;

        const anyoneWithAnimal = occupiedPlacements.some(
          (p) => p.animalInPlacement === true,
        );

        const anyoneWithAllergies = occupiedPlacements.some(
          (p) => p.hasPetAllergies === true,
        );

        const anyRoommateUnwillingToLiveWithEsa = occupiedPlacements.some(
          (p) => p.roommatesHaveEmotionalSupportAnimal !== true,
        );

        if ((anyoneWithAnimal && anyoneWithAllergies)
          || (anyoneWithAnimal && anyRoommateUnwillingToLiveWithEsa)) {
          return true; // Conflict detected
        }

        return false;
      },

      hasGenderConflict(placementModels) {
        if (!placementModels || placementModels.length < 2) return false;

        const occupiedPlacements = placementModels.filter((p) => p.fullName);
        if (occupiedPlacements.length < 2) return false;

        const hasGenderData = occupiedPlacements.some(
          (p) => p.gender !== undefined,
        );

        if (!hasGenderData) {
          return false;
        }

        // Check each student against their roommates preferred genders
        return occupiedPlacements.some((student) => {
          if (!student.gender) return false;

          const roommates = occupiedPlacements.filter((p) => p.placementId !== student.placementId);

          return roommates.some((roommate) => {
            if (!roommate.liveWithSameGenders) return false;

            if (roommate.liveWithSameGenders === 'Any') return false;

            if (roommate.liveWithSameGenders === 'Same') {
              return roommate.gender !== student.gender;
            }

            if (roommate.liveWithSameGenders === 'Other'
                && roommate.preferredRoommateGenders
                && roommate.preferredRoommateGenders.length > 0) {
              return !roommate.preferredRoommateGenders.includes(student.gender);
            }

            return false;
          });
        });
      },
    };
  },
  components: {
    SubmitPlacement,
    PlacementAudit,
  },
};
</script>

<style scoped>
.bg-buyout {
  background: #a2aa33 !important;
}
</style>
